import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from "react-window";
import React, { memo, useRef, useMemo, useState, useEffect, useCallback } from "react";
import { getChatBotGlobalParamsFetch } from "../../fetch/index/agentNew"

import Paper from '@mui/material/Paper';
// import MenuIcon from '@mui/icons-material/Menu';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { Grid, Fab, Link, IconButton, Typography, OutlinedInput, Badge } from "@mui/material";

import { SENT_AGENT, baseURL } from "../../commons/api_url"
import { formatTimeAgo, transformFun } from '../../commons/helps'
import { getAgentHistoryFetch } from "../../fetch/index/agentNew"
import GridTextComponent from "../components/GridTextComponent"
import CloseIcon from '@mui/icons-material/Close';

import ProgressComponent from '../../components/progress';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import DraftsIcon from '@mui/icons-material/Drafts';
import "./index.css"
import RefreshIcon from '@mui/icons-material/Refresh';
import { avatarFormat } from "../../commons/helps";
import IMAGELOGO from "../../assets/image/logo.svg";
import LeadsFormComponent from "../components/LeadsFormComponent";
import useAddTargetBlankToLinks from "../../components/useOpenLinksInNewTab"
let time;
let reconnectAttempts = 0;
let reconnectAttempts2 = 0;
const maxReconnectAttempts = 10;
let sendMessageToIframeTime = null
const ChatApp = (props) => {
    /***
     * scriptType 是iframe摸索 还是 script模式
     * */
    const { converationId, createNewConversation, globalparams, styleLoading, scriptType, reloadChatHistory, reloadChatHistoryCallBack, callBackLock, callBackIsShow,
        unreadAmount, leadsInfo, leadsWeclome, publicUUID, businessAccountId, projectId, agentId, innerScriptType } = props;
    const [messages, setMessages] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agentAvatar, setAgentAvatar] = useState("1");
    const listRef = useRef(null); // 用于引用 List 组件
    const [inputError, setInputError] = useState(false);
    const [isShow, setIsShow] = useState(scriptType === "iframe" ? true : false);
    // 是否锁住输入框
    const [lock, setLock] = useState(false);
    const signal = useRef(null);
    const controller = useRef(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [humanTaking, setHumanTaking] = useState(false);
    const [publicChat, setPublicChat] = useState(false);
    const [leadsShow, setLeadsShow] = useState(false);
    const messagesRef = useRef([])
    // useAddTargetBlankToLinks("chatbot_box");
    // const autoPopupRef = useRef(true)

    const iframeRef = useRef(null);
    // 发送消息到 iframe
    const sendMessageToIframe = () => {
        if (iframeRef.current && iframeRef.current.contentWindow) {
            iframeRef.current.contentWindow.postMessage("res", "*");
            sendMessageToIframeTime && clearTimeout(sendMessageToIframeTime)
        } else {
            sendMessageToIframeTime = setTimeout(sendMessageToIframe, 2000);
        }
    };
    useEffect(() => {
        return () => {
            sendMessageToIframeTime && clearInterval(sendMessageToIframeTime)
        }
    }, [])

    useEffect(() => {
        // 监听父窗口发来的消息
        const handleMessage = (event) => {
            if (event.data === "res" && !localStorage.getItem(`${projectId}_converationId`)) {
                createNewConversation()
            } else if (event.data === "iframe_ready" && !localStorage.getItem(`${projectId}_converationId`)) {
                createNewConversation()
            }
            // 更新消息
        };

        // 添加事件监听
        window.addEventListener('message', handleMessage);

        // 清理监听器
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    useEffect(() => {
        messagesRef.current = messages
    }, [messages])
    // 是否是 管理员 替代 机器人
    const isHumanTaking = publicChat && humanTaking;

    // 当前 接受消息
    const [eventSource, setEventSource] = useState(false);
    const [eventSourceHumanTaking, setSeventSourceHumanTaking] = useState(false)

    useEffect(() => {
        callBackLock(lock)
    }, [lock])

    useEffect(() => {
        if (isShow) {
            callBackIsShow(isShow)
            sendMessageToIframe()
        }
    }, [isShow])


    useEffect(() => {
        // 处理窗口大小变化
        const handleResize = debounce(() => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }, 500); // 设置防抖时间（毫秒）

        // 添加事件监听器
        window.addEventListener('resize', handleResize);

        // 组件卸载时移除事件监听器
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const createSigna = () => {
        // 创建一个新的 AbortController 实例
        const controllerTemp = new AbortController();
        const signalTemp = controllerTemp.signal;
        signal.current = signalTemp;
        controller.current = controllerTemp;
    }

    const clearSigna = () => {
        if (controller.current) {
            controller.current.abort();
        }
        signal.current = null;
        controller.current = null;
    }

    useEffect(() => {
        if (converationId && scriptType === "iframe") {
            if (eventSourceHumanTaking) {
                eventSourceHumanTaking.close();
                setSeventSourceHumanTaking(false)
            }
            // eslint-disable-next-line no-unused-expressions
            clearSigna()// 清除 实例
            createSigna()// 创建一个新的 AbortController 实例
            setMessages([])
            setAgentAvatar("1");
            setLock(false)
            setLoading(false);
            setPageLoading(true)
            getHistory(converationId)
            setHumanTaking(false);
            setPublicChat(false);
            setSentStopStatus("sent")
            addEventListenerIsHumanTaking()
        }

        return () => clearSigna();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [converationId])

    // 当 未读消息大于1重新加载
    useEffect(() => {
        if (reloadChatHistory && scriptType === "iframe") {
            // eslint-disable-next-line no-unused-expressions
            clearSigna();
            createSigna()// 创建一个新的 AbortController 实例
            setLock(false)
            setLoading(false);
            getHistory(converationId, 'type')
            setSentStopStatus("sent")
        }
    }, [reloadChatHistory])
    /**
     * 
     * =START 监听 是否是接管状态 重新创建 新的流 监听用户 chatbot测发送的消息 ========================================================
     * 
     */
    useEffect(() => {
        if (isHumanTaking) {
            if (eventSource) {
                eventSource.close();
                setEventSource(false)
            }
            reconnectAttempts = 0; // Reset on successful connection
            connectEventSource()
        } else if (eventSource) {
            eventSource.close();
            setEventSource(false)
            reconnectAttempts = 0; // Reset on successful connection
        }
    }, [isHumanTaking])
    useEffect(() => {
        return () => {
            if (eventSource) {
                eventSource.close();
                setEventSource(false)
            }
            if (eventSourceHumanTaking) {
                eventSourceHumanTaking.close();
                setSeventSourceHumanTaking(false)
            }
        }
    }, [])
    function exponentialBackoff(attempt) {
        return Math.min(1000 * 2 ** attempt, 30000); // Max delay of 30 seconds
    }

    const connectEventSource = () => {
        const eventSourceResult = new EventSource(`${baseURL}${SENT_AGENT}${converationId}/human_chat_stream?from_console=false`);
        setEventSource(eventSourceResult)
        eventSourceResult.onopen = function () {
            reconnectAttempts = 0; // Reset on successful connection
        };

        // Event listener for incoming messages from the server (admin)
        eventSourceResult.onmessage = function (event) {
            // Parse the incoming data
            const data = JSON.parse(event.data);
            if (data?.type === "output") {
                const text = data?.messages?.map(l => l.content);
                pustMessage(text)
            }
        };

        eventSourceResult.onerror = function (event) {
            console.error('EventSource error:', event);
            eventSourceResult.close();

            if (reconnectAttempts < maxReconnectAttempts) {
                const delay = exponentialBackoff(reconnectAttempts);
                setTimeout(connectEventSource, delay);
                // eslint-disable-next-line no-plusplus
                reconnectAttempts++;
            } else {
                console.error('Max reconnection attempts reached.');
            }
        };

        // Function to close the EventSource when the user leaves the page
        window.addEventListener('beforeunload', () => {
            eventSourceResult.close();
        });
    }

    // 监听 是否接管和取消接管了
    const addEventListenerIsHumanTaking = () => {
        const eventSourceResult = new EventSource(`${baseURL}${SENT_AGENT}${converationId}/status`);
        setSeventSourceHumanTaking(eventSourceResult)
        eventSourceResult.onopen = function () {
            reconnectAttempts2 = 0; // Reset on successful connection
        };
        eventSourceResult.onmessage = function (event) {
            try {
                const json = JSON.parse(event?.data)
                if (json.humanTaking || json?.humanTaking?.indexOf?.("True") > -1) {
                    setHumanTaking(true)
                } else {
                    setHumanTaking(false)
                }
            } catch (error) {
                if (event.data.indexOf("False") > -1) {
                    setHumanTaking(false)
                } else {

                    setHumanTaking(true)
                }

            }
        };

        eventSourceResult.onerror = function (event) {
            console.error('EventSource error:', event);
            eventSourceResult.close();

            if (reconnectAttempts2 < maxReconnectAttempts) {
                const delay = exponentialBackoff(reconnectAttempts2);
                setTimeout(addEventListenerIsHumanTaking, delay);
                // eslint-disable-next-line no-plusplus
                reconnectAttempts2++;
            } else {
                console.error('Max reconnection attempts reached.');
            }
        };

        // Function to close the EventSource when the user leaves the page
        window.addEventListener('beforeunload', () => {
            eventSourceResult.close();
        });
    }
    const pustMessage = (text) => {
        const mess = JSON.parse(JSON.stringify(messagesRef.current))?.filter(l => (!(l.type === "workflow" || l.type === "sheet")))
        const currentTime = new Date().getTime();
        mess.push({ position: 'left', type: 'text', text, date: currentTime, timestamp: currentTime })
        setMessages(mess)
    }
    /**
     * 
     * = END 监听 是否是接管状态 重新创建 新的流 监听用户 chatbot测发送的消息 ========================================================
     * 
     */

    const getHistory = async (id, type) => {
        try {
            const res = await getAgentHistoryFetch(id);
            if (res) {
                if (type) {
                    setMessages([])
                }
                setPublicChat(!!res?.publicChat);
                setHumanTaking(!!res.humanTaking);
                if (res?.history) {
                    const arrayList = transformFun(res?.history);
                    setMessages(arrayList);
                }
                setAgentAvatar(res?.avatar);
                reloadChatHistoryCallBack?.(false)
            } else {
                if (!innerScriptType) {
                    createNewConversation()
                } else {
                    localStorage.removeItem(`${projectId}_converationId`)
                }
            }
        } catch (error) {
            // 
            console.log(error);

        }
        setPageLoading(false)
    }




    const [inputValue, setInputValue] = useState("");
    const itemHeights = useRef({}); // 存储每个消息的高度


    const getItemSize = (index) => itemHeights.current[index] || 100;
    const [sentStopStatus, setSentStopStatus] = useState("sent")



    const [currentText, setCurrentText] = useState('');
    const stopFetch = () => {
        if (controller.current) {
            setSentStopStatus("sent")
        };
        clearSigna()// 清除 实例
    }
    const fetchEventStream = async () => {
        if (inputValue.trim() === "") {
            setInputError(true);
            return
        }

        // 判断是否需要 leads 表单提交 leadsWeclome

        if (leadsInfo?.length && !leadsShow && !localStorage.getItem("leads")) {
            setLeadsShow(true);
            setMessages(prevMessages => [...prevMessages,
            { position: 'right', type: 'text', text: inputValue, date: new Date().getTime() },
            { position: 'left', type: 'leads', text: leadsWeclome, date: new Date().getTime() },
            ])
            localStorage.setItem("leads", true)
            return
        }


        setLoading(true);
        setMessages(prevMessages => [...prevMessages,
        { position: 'right', type: 'text', text: inputValue, date: new Date().getTime() }
        ])
        scrollToBottom2()
        const language = navigator.language || navigator.userLanguage;
        const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
        const messagess = {
            "messages": [
                { "subject": "user", "content": inputValue, attachedFiles: "" }
            ],
            "user_timezone": timeZone,
            "user_time": new Date().toString(),
            "user_lang": language,
        };
        setInputValue("");
        const chatEndpoint = `${baseURL}${SENT_AGENT}${converationId}`;
        try {
            createSigna();
            const response = await fetch(chatEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(messagess),
                signal: signal.current
            })
            if (isHumanTaking) {
                artificialEventStream(response.body)
                return
            }
            setLoading(false);

            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');

            let partialData = '';

            while (true) {
                // eslint-disable-next-line no-await-in-loop
                const { done, value } = await reader.read();
                if (done) {
                    setSentStopStatus("sent")
                    break
                };
                setSentStopStatus("stop")


                partialData += decoder.decode(value, { stream: true });


                let lineStart = partialData.indexOf('data:');
                while (lineStart !== -1) {
                    const nextLineStart = partialData.indexOf('data:', lineStart + 5);

                    // 如果找到了下一个数据块的起始位置，就将当前数据块提取出来
                    const lineEnd = nextLineStart !== -1 ? nextLineStart : partialData.length;

                    const line = partialData.slice(lineStart + 5, lineEnd).trim();

                    try {
                        const escapedString = line.replace(/\n/g, '\\n');

                        const data = JSON.parse(escapedString);
                        if (data.type === 'output') {
                            const { content } = data.messages[0];
                            printCharacterByCharacter(content);  // 逐字打印
                        } else if (data?.lock) {
                            setLock(true)
                        } else {
                            setLock(false)
                        }
                    } catch (error) {
                        console.error('Error parsing JSON:', error);
                    }

                    // 更新 partialData，继续处理
                    partialData = partialData.slice(lineEnd);
                    lineStart = partialData.indexOf('data:');
                }
            }
        } catch (error) {
            if (error.name === "AbortError") {
                clearSigna()
            }
            setLoading(false);
        }

    };
    // 打印逐个字符
    const printCharacterByCharacter = async (text) => {
        await new Promise(resolve => requestAnimationFrame(resolve));

        // 更新消息状态
        setMessages(prevMessages => {
            const lastMessage = prevMessages[prevMessages.length - 1];
            if (lastMessage && lastMessage.position === 'left') {
                setCurrentText(e => `${e}${text}`)
                return [
                    ...prevMessages.slice(0, -1),
                    {
                        ...lastMessage,
                        text: `${lastMessage.text}${text}`, // 追加新字符
                        date: new Date().getTime(),
                    },
                ];
            }
            return [
                ...prevMessages,
                { position: 'left', type: 'text', text, date: new Date().getTime() },
            ];

        });
    };

    const scrollToBottom = (index) => {
        if (listRef.current) {
            listRef?.current?.scrollToItem?.(index, 'end');
        }
    }

    const scrollToBottom2 = useCallback(() => {
        if (listRef.current) {
            const index = messages.length - 1
            listRef?.current?.scrollToItem?.(index, 'end');
        }
    }, [messages.length]);

    useEffect(() => {
        const index = messages.length - 1
        time = setTimeout(() => {
            scrollToBottom(index); // 每次 currentText 更新时尝试滚动
        }, 500)
        return () => time && clearTimeout(time);
    }, [JSON.stringify(listRef?.current?.props ?? {})]);

    useEffect(() => {
        time = setTimeout(() => {
            scrollToBottom2();
        }, 500)
    }, [currentText, messages.length, JSON.stringify(itemHeights)]);

    const handleResize = (index, height) => {
        itemHeights.current[index] = height;
        if (listRef.current) {
            listRef.current.resetAfterIndex(index);
        }
    };

    const ImagesStytem = useMemo(() => <Grid
        sx={{
            padding: "2px",
            borderRadius: "50%",
        }}>
        <img src={avatarFormat(globalparams?.botAvatar ?? agentAvatar)} alt="" />
    </Grid>, [globalparams?.botAvatar])

    const ImagesUser = useMemo(() => <Grid
        sx={{
            borderRadius: "50%",
            padding: "2px",
        }}
    >
        <img src={avatarFormat(globalparams?.userAvatar ?? agentAvatar)} alt="" />
    </Grid>, [globalparams?.userAvatar])

    // eslint-disable-next-line react/no-unstable-nested-components
    const Row = memo(({ index, style }) => {
        const messageBoxRef = useRef(null);

        useEffect(() => {
            const node = messageBoxRef.current;
            if (node) {
                const { height } = node.getBoundingClientRect();
                handleResize(index, height);
            }
        }, [index]);
        const item = messages[index];
        // position
        const imageStyle = {}
        if (item.position === "left") {
            imageStyle.left = -32
        } else if (item.position === "right") {
            imageStyle.right = -32
        }

        const reduisStyle = {
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
        }
        const itemStyle = { maxWidth: "800px", minWidth: "50px" }
        if (item.position === "left") {
            itemStyle.paddingLeft = "34px"
            reduisStyle['borderTopRightRadius'] = "20px"
            reduisStyle['borderTopLeftRadius'] = "6px"
            // itemStyle.paddingRight = "10%"
        } else if (item.position === "right") {
            itemStyle.paddingRight = "34px"
            // itemStyle.paddingLeft = "10%"
            reduisStyle['borderTopLeftRadius'] = "20px"
            reduisStyle['borderTopRightRadius'] = "6px"
        }

        return (
            <Grid style={style}>
                <Grid ref={messageBoxRef} sx={{ display: "flex", justifyContent: item.position === "left" ? "flex-start" : "flex-end" }} >
                    <Grid sx={{
                        padding: "10px",
                        ...itemStyle
                    }}>
                        <Grid sx={{
                            padding: "6px 12px",
                            backgroundColor: item.position === "left" ? (globalparams?.botMessageBg ?? "#ffffff") : (globalparams?.userMessageBg ?? "#1877f212"),
                            position: "relative",
                            ...reduisStyle,
                        }}>
                            <Grid sx={{
                                position: "absolute",
                                ...imageStyle,
                                top: '0px',
                                padding: 0,
                                zIndex: 999,
                                overflow: "hidden",
                                width: "26px",
                                height: "26px",
                                display: "flex",
                                alignItems: "center", justifyContent: "center"
                            }}>
                                {item.position === "left" ? ImagesStytem : ImagesUser}
                            </Grid>
                            <Grid sx={{}}>
                                {/* <Typography variant="body2" sx={{
                                    whiteSpace: "pre-wrap",
                                    color: item.position === "left" ?
                                        (globalparams?.botMessageText ?? "#212B36") :
                                        (globalparams?.userMessageText ?? "#212B36")
                                }}>
                                    {item.text}
                                </Typography> */}
                                {/* <LeadsFormComponent leadsWeclome={leadsWeclome} leadsInfo={leadsInfo} converationId={converationId} /> */}
                                {
                                    item.position === "left" ?
                                        item.type === "leads" ?
                                            <LeadsFormComponent leadsWeclome={leadsWeclome} leadsInfo={leadsInfo} converationId={converationId} /> :
                                            (<GridTextComponent value={item.text} type="html" position={item.position} />)
                                        : (
                                            <Typography variant="body2" color="primary" sx={{
                                                whiteSpace: "pre-wrap",
                                                color: globalparams?.userMessageText ?? "#212B36"
                                            }}>{item.text}</Typography>
                                        )
                                }
                                <style>
                                    {`
                                        .prose.${item.position}{
                                            color: ${item.position === "left" ?
                                            (globalparams?.botMessageText ?? "#212B36") :
                                            (globalparams?.userMessageText ?? "#212B36")
                                        } !important;
                                        }
                                    `}
                                </style>
                                <Typography variant="body2" sx={{
                                    textAlign: item.position === "left" ? "left" : "right",
                                    fontSize: "12px",
                                    paddingRight: "10px",
                                    marginTop: "2 px",
                                    color: item.position === "left" ?
                                        (globalparams?.botMessageText ?? "#212B36") :
                                        (globalparams?.userMessageText ?? "#212B36"),
                                    opacity: 0.6
                                }}  >{formatTimeAgo(item.date)}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        )
    });

    const Renders = useMemo(() => (
        <Grid style={{ flex: 1, position: "relative", paddingTop: "10px", backgroundColor: globalparams?.contentBg }}>
            {
                pageLoading ?
                    (<ProgressComponent loading={pageLoading} type="inner" text='Loading...' backgroundColor="transparent" marginTop="20px" />) :
                    <AutoSizer className='test'>
                        {({ height, width }) => (
                            <List
                                height={height}
                                width={width}
                                itemCount={messages.length}
                                itemSize={getItemSize}
                                ref={listRef}
                            >
                                {Row}
                            </List>
                        )}
                    </AutoSizer>

            }

        </Grid>

    ), [converationId, JSON.stringify(messages), messages.length, pageLoading, JSON.stringify(windowSize), JSON.stringify(leadsInfo)])

    /**
      * 
      * 管理员接管状态下 交互发送 处理消息逻辑
      * 
      */
    const artificialEventStream = async (body) => {
        setLoading(false);
    }


    // tool_calls数组最后一个数据不是空不能发消息  lock 锁住后 不能输入
    const tool_calls = messages[(messages?.length ?? 1) - 1]?.tool_calls?.length > 0
    const contentRender = () => {

        let contentStyle = {
            maxHeight: "100%",
            maxWidth: "100%",
            flexDirection: "column",
            overflow: "hidden",
            borderRadius: "8px",
            display: "flex",
            boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
        }

        if (scriptType === "iframe") {
            contentStyle = {
                ...contentStyle,
                height: "100%",
                width: "100%",
                borderRadius: 0
            }
        } else {
            contentStyle = {
                ...contentStyle,
                position: 'fixed',
                bottom: { xs: 0, sm: 0, md: 80, lg: 80, xl: 80 },
                right: { xs: 0, sm: 0, md: 20, lg: 20, xl: 20 },
                height: { xs: '100vh', sm: '100vh', md: '600px', lg: '600px', xl: '600px' },
                width: { xs: '100vw', sm: '100vw', md: '400px', lg: '400px', xl: '400px' },
            }
        }

        return (
            <Grid
                className={`rcw-conversation-container chat-box ${isShow ? 'show' : ''}`}
                sx={contentStyle}>
                <Grid sx={{ height: "80px", flexShrink: 0, backgroundColor: globalparams?.headerBgColor ?? "#000000", position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <IconButton onClick={() => createNewConversation()} sx={{ p: '10px', }} aria-label="menu">
                        <RefreshIcon sx={{ color: globalparams?.headerTextColor ?? "#ffffff" }} />
                    </IconButton>
                    <Typography variant='h4' sx={{ color: globalparams?.headerTextColor ?? "#ffffff", textAlign: "center" }}>{globalparams.headerTitle}</Typography>
                    {
                        scriptType === "iframe" ? <Grid sx={{ width: "44px" }}></Grid> : (
                            <IconButton onClick={() => {
                                setIsShow(e => !e)
                                localStorage.setItem(`${projectId}_autoPopup`, true);
                            }} sx={{ p: '10px', }} aria-label="menu">
                                <CloseIcon sx={{ color: globalparams?.headerTextColor ?? "#ffffff" }} />
                            </IconButton>
                        )
                    }
                </Grid>
                <Grid
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        position: "relative",
                    }}>
                    {Renders}
                    <Grid sx={{ width: "100%", background: globalparams?.footerBg ?? "#f5f5fa", padding: "10px 0", display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center" }}>
                        <Paper
                            component="form"
                            sx={{
                                p: '8px 16px', display: 'flex', alignItems: 'center', width: "90%",
                                boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px"
                            }}
                        >
                            {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
                    <MenuIcon />
                </IconButton> */}
                            <OutlinedInput
                                onChange={e => {
                                    setInputError(false);
                                    setInputValue(e?.target?.value)
                                }}
                                onKeyPress={(event) => {
                                    if (event.code === 'Enter' && (event.altKey || event.ctrlKey || event.shiftKey)) {
                                        event.preventDefault();
                                        const input = event.target;
                                        const { selectionStart } = input;
                                        const { selectionEnd } = input;

                                        // 在光标位置插入换行符
                                        const newValue =
                                            `${input.value.substring(0, selectionStart)}\n${input.value.substring(selectionEnd)}`;

                                        setInputValue(newValue);

                                        // 更新后异步执行滚动逻辑
                                        setTimeout(() => {
                                            // 确保光标仍在插入位置
                                            input.setSelectionRange(selectionStart + 1, selectionStart + 1);

                                            // 将光标位置滚动到可视区域
                                            input.scrollTop = input.scrollHeight;
                                        }, 0);
                                    } else if (event.code === 'Enter') {
                                        if (pageLoading || !converationId || tool_calls || lock) {

                                        } else {
                                            fetchEventStream()
                                        }
                                        event.preventDefault();
                                    }
                                }}
                                error={inputError}
                                size="small"
                                multiline
                                maxRows={4}
                                sx={{ ml: 1, flex: 1, borderRadius: "4px", padding: '4px', marginRight: "10px" }}
                                placeholder={globalparams?.placeholder ?? "Input ..."}
                                value={inputValue}
                                id="outlined-adornment-weight"
                                // endAdornment={<InputAdornment position="end">kg</InputAdornment>}
                                aria-describedby="outlined-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                }}
                            />
                            <LoadingButton
                                size='small'
                                loading={loading}
                                loadingPosition="start"
                                startIcon={sentStopStatus === "sent" ? <SendIcon /> : <StopCircleIcon />}
                                variant="contained"
                                color={sentStopStatus === "sent" ? "inherit" : "error"}
                                sx={
                                    sentStopStatus === "sent" ? {
                                        color: globalparams?.btnTextColor ?? "#ffffff",
                                        background: globalparams?.btnBgColor ?? "#ffffff",
                                        "&:hover": {
                                            color: globalparams?.btnTextColor ?? "#ffffff",
                                            background: globalparams?.btnBgColor ?? "#ffffff",
                                        }
                                    } : {}}
                                onClick={sentStopStatus === "sent" ? fetchEventStream : stopFetch}
                                disabled={pageLoading || !converationId || tool_calls || lock}
                            >
                                {sentStopStatus === "sent" ? "Send" : "Stop"}
                            </LoadingButton>
                        </Paper>
                        {
                            !globalparams?.removeLogo && (
                                <Grid sx={{ marginTop: "10px", color: "#b5abab", fontSize: "12px", display: "flex", alignItems: "center", marginRight: "4px" }}>
                                    <Link target="_blank" color="inherit"
                                        sx={{ color: "#b5abab", fontSize: "12px", display: "flex", alignItems: "center", textDecoration: "none", wordBreak: "break-all", flexWrap: "wrap" }}
                                        href={globalparams?.customLogoWebsite ?? "https://burstyai.com"}>
                                        {globalparams?.customLogoText ?? "Powered by"}
                                        <img src={globalparams?.customLogoUrl ?? IMAGELOGO} alt=''
                                            style={{ height: "18px", display: "inline-block", marginLeft: "8px" }} />
                                    </Link>
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
            </Grid >

        )
    }

    // 悬浮按钮
    const fabRender = () => {
        if (scriptType === "iframe") return ""
        return (
            <Badge badgeContent={unreadAmount} color="error">
                <Fab
                    className={`fab ${isShow ? 'rotate bounce' : globalparams?.fabAnimation}`} // 使用 show 状态来控制动效
                    aria-label=""
                    onClick={() => setIsShow(e => !e)}
                    sx={{
                        "&:hover": {
                            background: globalparams?.btnBgColor ?? "#000000",
                            color: globalparams?.btnTextColor ?? "#ffffff",

                        },
                        background: globalparams?.btnBgColor ?? "#000000",
                        color: globalparams?.btnTextColor ?? "#ffffff",
                        overflow: "hidden",
                        marginBottom: "20px",
                        marginTop: "10px",
                        display: isShow ? {
                            xs: "none",
                            sm: "none",
                            md: "flex",
                            lg: "flex",
                            xl: "flex",
                        } : "flex",
                    }}
                >
                    {styleLoading ?
                        <ProgressComponent loading={styleLoading} color={"#ffffff"} type="inner" backgroundColor="transparent" /> :
                        (!isShow ? <LocalPostOfficeIcon /> : <DraftsIcon />)
                    }
                </Fab>
            </Badge>

        )
    }


    if (scriptType === "iframe") {
        return <>{contentRender()}</>
    }

    return (
        <Grid
            className={`chatbot_box`}
            sx={{
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                position: scriptType !== "iframe" ? 'fixed' : "relative",
                zIndex: 9999999,
                right: { xs: 0, sm: 0, md: '20px', lg: '20px', xl: '20px' },
                alignItems: "flex-end",
            }}>
            {scriptType === "iframe" && contentRender()}
            {scriptType !== "iframe" && <Grid
                className={`rcw-conversation-container chat-box ${isShow ? 'show' : ''}`}
                sx={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    flexDirection: "column",
                    overflow: "hidden",
                    borderRadius: "8px",
                    display: "flex",
                    boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
                    position: 'fixed',
                    bottom: { xs: 0, sm: 0, md: 80, lg: 80, xl: 80 },
                    right: { xs: 0, sm: 0, md: 20, lg: 20, xl: 20 },
                    height: { xs: '100vh', sm: '100vh', md: '600px', lg: '600px', xl: '600px' },
                    width: { xs: '100vw', sm: '100vw', md: '400px', lg: '400px', xl: '400px' },
                }}
            >

                <iframe
                    ref={iframeRef}
                    onLoad={() => {
                        setTimeout(async () => {
                            const res = await getChatBotGlobalParamsFetch(agentId, { businessAccountId: businessAccountId, projectId: projectId });
                            iframeRef.current.contentWindow.postMessage("iframe_ready", "*");
                            let popupDelay = res?.popupDelay;
                            console.log(res, isShow, localStorage.getItem(`${projectId}_autoPopup`));
                            if (res?.autoPopup && !isShow && !localStorage.getItem(`${projectId}_autoPopup`)) {
                                console.log("autoPopup");
                                popupDelay = isNaN(parseInt(popupDelay ?? 1)) ? 1 : parseInt(popupDelay)
                                // autoPopupRef.current = false;
                                setTimeout(() => {
                                    setIsShow(true)
                                }, ((popupDelay ?? 1) < 1 ? 1 : (popupDelay ?? 1)) * 1000);
                            }
                        }, 500); // 延迟 500ms 确保 `iframe` 完全加载
                    }}
                    title='chatbot'
                    style={{
                        height: "100%",
                        width: '100%',
                        border: 'none',
                        display: 'block',
                    }}
                    src={`https://app.burstyai.com/chatbot-iframes/${publicUUID}/${businessAccountId}/${projectId}/${agentId}/chatbot`} />

                <IconButton
                    onClick={() => {
                        setIsShow(e => !e)
                        localStorage.setItem(`${projectId}_autoPopup`, true);
                    }}
                    sx={{ p: '10px', position: "absolute", right: isShow ? "10px" : "0px", top: "20px", transition: "all 1s" }}
                    aria-label="menu"
                >
                    <CloseIcon sx={{ color: globalparams?.headerTextColor ?? "#ffffff" }} />
                </IconButton>
            </Grid>
            }
            {iframeRef?.current?.contentWindow?.postMessage && scriptType !== "iframe" && fabRender()}
            {scriptType === "iframe" && fabRender()}
        </Grid>

    );
};
ChatApp.propTypes = {
    createNewConversation: PropTypes.any,
    converationId: PropTypes.any,
    globalparams: PropTypes.any,
    styleLoading: PropTypes.any,
    reloadChatHistory: PropTypes.any,
    reloadChatHistoryCallBack: PropTypes.any,
    callBackLock: PropTypes.any,
    callBackIsShow: PropTypes.any,
    unreadAmount: PropTypes.any,
    scriptType: PropTypes.any,
    leadsInfo: PropTypes.any,
    leadsWeclome: PropTypes.any
};
export default ChatApp;
